import React from "react";

// Series 1 (SVG only)
import avatar_1_1 from "../resources/avatars/1_1.svg";
import avatar_1_2 from "../resources/avatars/1_2.svg";
import avatar_1_3 from "../resources/avatars/1_3.svg";
import avatar_1_4 from "../resources/avatars/1_4.svg";
import avatar_1_5 from "../resources/avatars/1_5.svg";
import avatar_1_6 from "../resources/avatars/1_6.svg";
import avatar_1_7 from "../resources/avatars/1_7.svg";
import avatar_1_8 from "../resources/avatars/1_8.svg";
import avatar_1_9 from "../resources/avatars/1_9.svg";

// Series 2 (S@2x @3x PNG)
import avatar_2_1 from "../resources/avatars/2_1.png";
import avatar_2_1_2x from "../resources/avatars/2_1@2x.png";
import avatar_2_1_3x from "../resources/avatars/2_1@3x.png";
import avatar_2_1_4x from "../resources/avatars/2_1@4x.png";

import avatar_2_2 from "../resources/avatars/2_2.png";
import avatar_2_2_2x from "../resources/avatars/2_2@2x.png";
import avatar_2_2_3x from "../resources/avatars/2_2@3x.png";
import avatar_2_2_4x from "../resources/avatars/2_2@4x.png";

import avatar_2_3 from "../resources/avatars/2_3.png";
import avatar_2_3_2x from "../resources/avatars/2_3@2x.png";
import avatar_2_3_3x from "../resources/avatars/2_3@3x.png";
import avatar_2_3_4x from "../resources/avatars/2_3@4x.png";

import avatar_2_4 from "../resources/avatars/2_4.png";
import avatar_2_4_2x from "../resources/avatars/2_4@2x.png";
import avatar_2_4_3x from "../resources/avatars/2_4@3x.png";
import avatar_2_4_4x from "../resources/avatars/2_4@4x.png";

import avatar_2_5 from "../resources/avatars/2_5.png";
import avatar_2_5_2x from "../resources/avatars/2_5@2x.png";
import avatar_2_5_3x from "../resources/avatars/2_5@3x.png";
import avatar_2_5_4x from "../resources/avatars/2_5@4x.png";

import avatar_2_6 from "../resources/avatars/2_6.png";
import avatar_2_6_2x from "../resources/avatars/2_6@2x.png";
import avatar_2_6_3x from "../resources/avatars/2_6@3x.png";
import avatar_2_6_4x from "../resources/avatars/2_6@4x.png";

import avatar_2_7 from "../resources/avatars/2_7.png";
import avatar_2_7_2x from "../resources/avatars/2_7@2x.png";
import avatar_2_7_3x from "../resources/avatars/2_7@3x.png";
import avatar_2_7_4x from "../resources/avatars/2_7@4x.png";

import avatar_2_8 from "../resources/avatars/2_8.png";
import avatar_2_8_2x from "../resources/avatars/2_8@2x.png";
import avatar_2_8_3x from "../resources/avatars/2_8@3x.png";
import avatar_2_8_4x from "../resources/avatars/2_8@4x.png";

import avatar_2_9 from "../resources/avatars/2_9.png";
import avatar_2_9_2x from "../resources/avatars/2_9@2x.png";
import avatar_2_9_3x from "../resources/avatars/2_9@3x.png";
import avatar_2_9_4x from "../resources/avatars/2_9@4x.png";


// Series 3 (SVG only)
import avatar_3_1 from "../resources/avatars/3_1.svg";
import avatar_3_2 from "../resources/avatars/3_2.svg";
import avatar_3_3 from "../resources/avatars/3_3.svg";
import avatar_3_4 from "../resources/avatars/3_4.svg";
 

 
// Series 4 (S@2x @3x PNG)

import avatar_4_1 from "../resources/avatars/4_1.png";
import avatar_4_1_2x from "../resources/avatars/4_1@2x.png";
import avatar_4_1_3x from "../resources/avatars/4_1@3x.png";
import avatar_4_1_4x from "../resources/avatars/4_1@4x.png";

import avatar_4_2 from "../resources/avatars/4_2.png";
import avatar_4_2_2x from "../resources/avatars/4_2@2x.png";
import avatar_4_2_3x from "../resources/avatars/4_2@3x.png";
import avatar_4_2_4x from "../resources/avatars/4_2@4x.png";

import avatar_4_3 from "../resources/avatars/4_3.png";
import avatar_4_3_2x from "../resources/avatars/4_3@2x.png";
import avatar_4_3_3x from "../resources/avatars/4_3@3x.png";
import avatar_4_3_4x from "../resources/avatars/4_3@4x.png";

import avatar_4_4 from "../resources/avatars/4_4.png";
import avatar_4_4_2x from "../resources/avatars/4_4@2x.png";
import avatar_4_4_3x from "../resources/avatars/4_4@3x.png";
import avatar_4_4_4x from "../resources/avatars/4_4@4x.png";

 

const avatarMap: Record<
  string,
  {
    svg: string;
    "2x"?: string;
    "3x"?: string;
    "4x"?: string;
  }
> = {
  // Series 1 (SVG only)
  "1_1": { svg: avatar_1_1 },
  "1_2": { svg: avatar_1_2 },
  "1_3": { svg: avatar_1_3 },
  "1_4": { svg: avatar_1_4 },
  "1_5": { svg: avatar_1_5 },
  "1_6": { svg: avatar_1_6 },
  "1_7": { svg: avatar_1_7 },
  "1_8": { svg: avatar_1_8 },
  "1_9": { svg: avatar_1_9 },

  // Series 2
  "2_1": {
    svg: avatar_2_1,
    "2x": avatar_2_1_2x,
    "3x": avatar_2_1_3x,
    "4x": avatar_2_1_4x,
  },
  "2_2": {
    svg: avatar_2_2,
    "2x": avatar_2_2_2x,
    "3x": avatar_2_2_3x,
    "4x": avatar_2_2_4x,
  },
  "2_3": {
    svg: avatar_2_3,
    "2x": avatar_2_3_2x,
    "3x": avatar_2_3_3x,
    "4x": avatar_2_3_4x,
  },
  "2_4": {
    svg: avatar_2_4,
    "2x": avatar_2_4_2x,
    "3x": avatar_2_4_3x,
    "4x": avatar_2_4_4x,
  },
  "2_5": {
    svg: avatar_2_5,
    "2x": avatar_2_5_2x,
    "3x": avatar_2_5_3x,
    "4x": avatar_2_5_4x,
  },
  "2_6": {
    svg: avatar_2_6,
    "2x": avatar_2_6_2x,
    "3x": avatar_2_6_3x,
    "4x": avatar_2_6_4x,
  },
  "2_7": {
    svg: avatar_2_7,
    "2x": avatar_2_7_2x,
    "3x": avatar_2_7_3x,
    "4x": avatar_2_7_4x,
  },
  "2_8": {
    svg: avatar_2_8,
    "2x": avatar_2_8_2x,
    "3x": avatar_2_8_3x,
    "4x": avatar_2_8_4x,
  },
  "2_9": {
    svg: avatar_2_9,
    "2x": avatar_2_9_2x,
    "3x": avatar_2_9_3x,
    "4x": avatar_2_9_4x,
  },

  // Series 3 (SVG only)
  "3_1": { svg: avatar_3_1 },
  "3_2": { svg: avatar_3_2 },
  "3_3": { svg: avatar_3_3 },
  "3_4": { svg: avatar_3_4 },

  // Series 4
  "4_1": {
    svg: avatar_4_1,
    "2x": avatar_4_1_2x,
    "3x": avatar_4_1_3x,
    "4x": avatar_4_1_4x,
  },
  "4_2": {
    svg: avatar_4_2,
    "2x": avatar_4_2_2x,
    "3x": avatar_4_2_3x,
    "4x": avatar_4_2_4x,
  },
  "4_3": {
    svg: avatar_4_3,
    "2x": avatar_4_3_2x,
    "3x": avatar_4_3_3x,
    "4x": avatar_4_3_4x,
  },
};

type AvatarImageProps = {
  name: string; // e.g., "2_1"
  size?: number;
  alt?: string;
  className?: string;
  onClick?: () => void; 
};

const AvatarImage: React.FC<AvatarImageProps> = ({ 
  name, 
  size = 40, 
  alt = "Avatar", 
  className= "",
  
  onClick // Accept onClick prop
}) => {
  const avatar = avatarMap[name];
  if (!avatar) return null;

  const { svg, "2x": img2x, "3x": img3x, "4x": img4x } = avatar;

  const srcSet = [img2x && `${img2x} 2x`, img3x && `${img3x} 3x`, img4x && `${img4x} 4x`]
    .filter(Boolean)
    .join(", ");

    return (
      <img
        src={svg}
        srcSet={srcSet || undefined}
        alt={alt}
       className={`${className} avatar-series-${name.split('_')[0]}`}
                 draggable={false} // Voorkomt slepen van de afbeelding
      onContextMenu={(e) => e.preventDefault()} // Blokkeert rechtermuisklik-contextmenu
      onDragStart={(e) => e.preventDefault()} // Extra blokkade voor drag-events
        style={{ 
          width: size, 
          height: size, 
              
          cursor: onClick ? 'pointer' : 'default' // Add cursor style for better UX
        }}
        onClick={onClick} // Pass onClick to the img element
      />
    );
  };

export default AvatarImage;
